import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxTextBoxComponent } from 'devextreme-angular';
import { AppService } from '../../app-service';
import { AppComponent } from '../../app.component';
import { ResponseObject } from '../../models/response-object';
import { UserDetail } from '../../models/users-models/user-details';
import { UsersService } from '../../services/users-services/users-service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { DialogMessageTypes, MessageDialogComponent } from '../common/message-dialog/message-dialog.component';
import { ProcessingDialogComponent } from '../common/processing-dialog/processing-dialog.component';
import { ResponseStatus } from '../enums/response-statuses';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  @ViewChild(MessageDialogComponent) messageDialog: MessageDialogComponent;
  @ViewChild(ProcessingDialogComponent) processingDialog: ProcessingDialogComponent;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent;
  @ViewChild("txtCurrentPassword", { static: true }) txtCurrentPassword: DxTextBoxComponent;
  @ViewChild("txtNewPassword", { static: true }) txtNewPassword: DxTextBoxComponent;
  passwordMode: String = "password";
  passwordButton: any;
  userDetails: LoginDetails = new LoginDetails();
  @ViewChild(DxTextBoxComponent, { static: true }) txtPassword: DxTextBoxComponent;
  changePasswordDetails: ChangePasswordDetails = new ChangePasswordDetails();
  resetPasswordDetails: ChangePasswordDetails = new ChangePasswordDetails();
  newPasswordButton: any;
  newPasswordMode: String = "password";
  isChangePasswordPopupVisible: Boolean = false;
  userDefaultDetails: UserDetail = new UserDetail()
  @ViewChild('username') loginUsername: ElementRef;
  @ViewChild('password') loginPassword: ElementRef;
  isForgotPasswordPopupVisible: Boolean = false;

  constructor(private usersService: UsersService,
    private appService: AppService,
    private myapp: AppComponent,
    private router: Router) {
    this.passwordButton = {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        this.passwordMode = this.passwordMode === "text" ? "password" : "text";
      }
    };
    this.newPasswordButton = {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        this.newPasswordMode = this.newPasswordMode === "text" ? "password" : "text";
      }
    };
  }

  forgotPassword() {
    this.resetPasswordDetails = new ChangePasswordDetails();
    this.resetPasswordDetails.Username = this.loginUsername.nativeElement.value;
    this.isForgotPasswordPopupVisible = true;
  }

  forgotPasswordCloseClick() {
    this.isForgotPasswordPopupVisible = false;
  }

  login() {
    this.userDetails.Username = this.loginUsername.nativeElement.value;
    this.userDetails.Password = this.loginPassword.nativeElement.value;
    if (this.userDetails.Username == "" || this.userDetails.Username == undefined || this.userDetails.Password == "" || this.userDetails.Password == undefined) {
      this.messageDialog.show("Provide your username and password.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      this.usersService.utilitiesGet("AuthenticateUser?username=" + this.userDetails.Username + "&password=" + this.userDetails.Password + "&save=true&save1=true").subscribe(
        data => {
          this.processingDialog.hide();
          let authenticationResponce: UserAuthenticationResponce = data;
          let response: ResponseObject = authenticationResponce.Response;
          if (response.Status == ResponseStatus.Success) {
            sessionStorage.setItem("GUID", authenticationResponce.GUID.toString());

            // if (authenticationResponce.GUID == "F570BDF4-4A2F-4F8F-AEA9-518011009B1D") { //Student portal

            //   this.appService.setTimeoutPeriod(+authenticationResponce.UserIdleSessionTimeOut.valueOf());
            //   this.appService.setTimeoutPeriodWarning(+authenticationResponce.UserIdleSessionTimeOutWarning.valueOf());

            //   sessionStorage.setItem("StudentNumber",authenticationResponce.LoggedInStudentDetails.StudentNumber.toString())
            //   sessionStorage.setItem("StudentName",authenticationResponce.LoggedInStudentDetails.Name.toString());
            //   sessionStorage.setItem("TermYears",authenticationResponce.LoggedInStudentDetails.TermYears.toString());
            //   sessionStorage.setItem("ClassID",authenticationResponce.LoggedInStudentDetails.ClassID.toString());
            //   sessionStorage.setItem("SchoolName",authenticationResponce.LoggedInStudentDetails.SchoolName.toString());

            //   sessionStorage.setItem("LicenseExpiryDate", authenticationResponce.LicenseExpiryDate.toString());
            //   sessionStorage.setItem("LicenseDaysLeft", authenticationResponce.LicenseDaysLeft.toString());
            //   sessionStorage.setItem("LicensedStudentsBalance", authenticationResponce.LicensedStudentsBalance.toString());
            //   sessionStorage.setItem("UnLicensedStudentsBalance", authenticationResponce.UnLicensedStudentsBalance.toString());
            //   sessionStorage.setItem("PasswordExpiryDate", authenticationResponce.PasswordExpiryDate.toString());
            //   sessionStorage.setItem("PaymentReceiptOption", authenticationResponce.PaymentReceiptOption.toString());
            //   sessionStorage.setItem("TeacherID", authenticationResponce.TeacherID.toString());
            //   sessionStorage.setItem("SMSsEnabled", authenticationResponce.SMSsEnabled.toString());
            //   sessionStorage.setItem("ExamTopicsEnabled", authenticationResponce.ExamTopicsEnabled.toString());
            //   sessionStorage.setItem("ManualStudentNumbers", authenticationResponce.ManualStudentNumbers.toString());
            //   sessionStorage.setItem("DefaultAbsentStudentNotification", authenticationResponce.DefaultAbsentStudentNotification.toString());

            //   this.myapp.getMenu();
            //   this.appService.setUserLoggedIn(true);
            //   this.router.navigate(['/', 'sp-dashboard']);
            // }
            // else if (sessionStorage.getItem("GUID") == "DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") {// eSchool System
            sessionStorage.setItem("LicenseExpiryDate", authenticationResponce.LicenseExpiryDate.toString());
            sessionStorage.setItem("LicenseDaysLeft", authenticationResponce.LicenseDaysLeft.toString());
            sessionStorage.setItem("LicensedStudentsBalance", authenticationResponce.LicensedStudentsBalance.toString());
            sessionStorage.setItem("UnLicensedStudentsBalance", authenticationResponce.UnLicensedStudentsBalance.toString());
            sessionStorage.setItem("PasswordExpiryDate", authenticationResponce.PasswordExpiryDate.toString());
            sessionStorage.setItem("PaymentReceiptOption", authenticationResponce.PaymentReceiptOption.toString());
            sessionStorage.setItem("TeacherID", authenticationResponce.TeacherID.toString());
            sessionStorage.setItem("CommentsSource", authenticationResponce.CommentsSource.toString());
            sessionStorage.setItem("SMSsEnabled", authenticationResponce.SMSsEnabled.toString());
            sessionStorage.setItem("BComments", authenticationResponce.BehaviourCommentsEnabled.toString());
            sessionStorage.setItem("RestrictedEndOfTermReports", authenticationResponce.RestrictedEndOfTermReports.toString());
            sessionStorage.setItem("ExamTopicsEnabled", authenticationResponce.ExamTopicsEnabled.toString());
            sessionStorage.setItem("ManualStudentNumbers", authenticationResponce.ManualStudentNumbers.toString());
            sessionStorage.setItem("DefaultAbsentStudentNotification", authenticationResponce.DefaultAbsentStudentNotification.toString());

            this.appService.setTimeoutPeriod(+authenticationResponce.UserIdleSessionTimeOut.valueOf());
            this.appService.setTimeoutPeriodWarning(+authenticationResponce.UserIdleSessionTimeOutWarning.valueOf());

            if (authenticationResponce.ChangePassword == true) {
              this.userDefaultDetails = authenticationResponce.UserDetails;
              this.changePasswordDetails = new ChangePasswordDetails();
              this.changePasswordDetails.Username = this.userDefaultDetails.Username;
              this.changePasswordDetails.FullName = this.userDefaultDetails.Name;
              this.txtCurrentPassword.value = this.userDetails.Password.valueOf();
              this.txtNewPassword.value = "";
              this.isChangePasswordPopupVisible = true;
            }
            else {
              sessionStorage.setItem("Username", authenticationResponce.UserDetails.Username.toString());
              sessionStorage.setItem("TeacherID", authenticationResponce.UserDetails.TeacherID.toString());
              sessionStorage.setItem("DefaultLevelName", authenticationResponce.UserDetails.DefaultLevel.toString());
              sessionStorage.setItem("DefaultLevelID", authenticationResponce.UserDetails.DefaultLevelID.toString());
              sessionStorage.setItem("DefaultTermID", authenticationResponce.UserDetails.DefaultTermID.toString());
              sessionStorage.setItem("DefaultTermName", authenticationResponce.UserDetails.DefaultTerm.toString());
              sessionStorage.setItem("DefaultClassID", authenticationResponce.UserDetails.DefaultClassID.toString());
              sessionStorage.setItem("DefaultClass", authenticationResponce.UserDetails.DefaultClass.toString());
              sessionStorage.setItem("DefaultPaymentType", authenticationResponce.UserDetails.DefaultPaymentType.toString());
              sessionStorage.setItem("TermYears", authenticationResponce.UserDetails.TermYears.toString());
              sessionStorage.setItem("GraphPalette", authenticationResponce.UserDetails.GraphPallete.toString());
              sessionStorage.setItem("CommentsSource", authenticationResponce.CommentsSource.toString());
              sessionStorage.setItem("PreferredScanner", authenticationResponce.UserDetails.PreferredScanner.toString());
              sessionStorage.setItem("FullName", authenticationResponce.UserDetails.Name.toString());
              sessionStorage.setItem("UserProfile", authenticationResponce.UserDetails.ProfileName.toString());
              sessionStorage.setItem("LastLoginDate", authenticationResponce.UserDetails.LastLoginDate.toString());
              sessionStorage.setItem("LastLoginTime", authenticationResponce.UserDetails.LastLoginTime.toString());
              sessionStorage.setItem("PasswordRecoveryOption", authenticationResponce.UserDetails.PasswordRecoveryOption.toString());
              sessionStorage.setItem("LoggedIn", "true");

              sessionStorage.setItem("CaptureHeadmasterComments", authenticationResponce.UserDetails.CaptureHeadmasterComments.toString());
              sessionStorage.setItem("Administration", authenticationResponce.UserDetails.Administration.toString());
              sessionStorage.setItem("Students", authenticationResponce.UserDetails.Students.toString());
              sessionStorage.setItem("Fees", authenticationResponce.UserDetails.Fees.toString());
              sessionStorage.setItem("Exams", authenticationResponce.UserDetails.Exams.toString());
              sessionStorage.setItem("Communication", authenticationResponce.UserDetails.Communication.toString());
              sessionStorage.setItem("ResourceCentre", authenticationResponce.UserDetails.ResourceCentre.toString());
              sessionStorage.setItem("Reports", authenticationResponce.UserDetails.Reports.toString());
              sessionStorage.setItem("Maintenance", authenticationResponce.UserDetails.Maintenance.toString());
              sessionStorage.setItem("Settings", authenticationResponce.UserDetails.Settings.toString());
              sessionStorage.setItem("Transport", authenticationResponce.UserDetails.Transport.toString());
              sessionStorage.setItem("Accomodation", authenticationResponce.UserDetails.Accomodation.toString());
              sessionStorage.setItem("Timetable", authenticationResponce.UserDetails.Timetable.toString());
              sessionStorage.setItem("eLearning", authenticationResponce.UserDetails.eLearning.toString());
              sessionStorage.setItem("Library", authenticationResponce.UserDetails.Library.toString());

              // sessionStorage.setItem("Expenditure", authenticationResponce.UserDetails.Expenditure.toString());           

              this.myapp.getMenu();
              this.appService.setUserLoggedIn(true);
              if (sessionStorage.getItem("GUID") == "DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") {// eSchool System
                this.router.navigate(['/', 'home']);
              }
              else if (authenticationResponce.GUID == "F570BDF4-4A2F-4F8F-AEA9-518011009B1D") { //Student portal
                sessionStorage.setItem("StudentNumber", authenticationResponce.LoggedInStudentDetails.StudentNumber.toString())
                sessionStorage.setItem("StudentName", authenticationResponce.LoggedInStudentDetails.Name.toString());
                sessionStorage.setItem("TermYears", authenticationResponce.LoggedInStudentDetails.TermYears.toString());
                sessionStorage.setItem("ClassID", authenticationResponce.LoggedInStudentDetails.ClassID.toString());
                sessionStorage.setItem("SchoolName", authenticationResponce.LoggedInStudentDetails.SchoolName.toString());
                this.router.navigate(['/', 'sp-dashboard']);
              }
            }
          }
          else if (response.Status == ResponseStatus.Failure) {
            this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
          }
          else {
            this.messageDialog.show("Login request can not be processed at the moment due system challenges.", DialogMessageTypes.SystemError);
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("Login request can not be processed at the moment due system challenges.", DialogMessageTypes.SystemError);
        }
      )
    }
  }

  changePasswordCloseClick() {
    this.isChangePasswordPopupVisible = false;
  }

  resetPasswordSaveClick() {
    if (this.resetPasswordDetails.Username == undefined || this.resetPasswordDetails.Username == "") {
      this.messageDialog.show("Provide your username.", DialogMessageTypes.Information);
    }
    else {
      this.confirmDialog.show("Reset Password", "Are you sure you want to reset password for " + this.resetPasswordDetails.Username + " and send it on email?");
    }
  }

  confirmClick() {
    this.isForgotPasswordPopupVisible = false;
    this.confirmDialog.hide();
    this.processingDialog.show();
    this.usersService.utilitiesGet("ForgotPassword?username=" + this.resetPasswordDetails.Username + "&save=true&save1=true&save2=true&save3=true&save4=true&save5=true").subscribe(
      data => {
        this.processingDialog.hide();
        let response: ResponseObject = data;
        if (response.Status == ResponseStatus.Success) {
          this.messageDialog.show("Password has been reset and sent on email. Check your email for the new password.", DialogMessageTypes.Information);
        }
        else if (response.Status == ResponseStatus.Failure) {
          this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
        }
        else {
          this.messageDialog.show("A system error was encountered sending new password on email. Contact the system administrator for manual password reset.", DialogMessageTypes.SystemError);
        }
      },
      error => {
        this.processingDialog.hide();
        this.messageDialog.show("A system error was encountered sending new password on email. Contact the system administrator for manual password reset.", DialogMessageTypes.SystemError);
      }
    )
  }


  changePasswordSaveClick() {
    this.changePasswordDetails.CurrentPassword = this.txtCurrentPassword.value;
    this.changePasswordDetails.NewPassword = this.txtNewPassword.value;
    if (this.changePasswordDetails.PasswordHint == undefined) {
      this.changePasswordDetails.PasswordHint = "";
    }
    if (this.changePasswordDetails.NewPassword == this.changePasswordDetails.CurrentPassword) {
      this.messageDialog.show("New password must be diferent from current password.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      this.usersService.utilitiesGet("/ChangePassword?username=" + this.changePasswordDetails.Username + "&password=" + this.changePasswordDetails.CurrentPassword + "&newPassword=" + this.changePasswordDetails.NewPassword + "&passwordHint=" + this.changePasswordDetails.PasswordHint).subscribe(
        data => {
          this.processingDialog.hide();
          let responce: ResponseObject = data;
          if (responce.Status == ResponseStatus.Success) {
            this.isChangePasswordPopupVisible = false;
            sessionStorage.setItem("PasswordExpiryDate", responce.StatusDescription.toString());
            sessionStorage.setItem("Username", this.userDefaultDetails.Username.toString());
            sessionStorage.setItem("TeacherID", this.userDefaultDetails.TeacherID.toString());
            sessionStorage.setItem("DefaultLevelName", this.userDefaultDetails.DefaultLevel.toString());
            sessionStorage.setItem("DefaultLevelID", this.userDefaultDetails.DefaultLevelID.toString());
            sessionStorage.setItem("DefaultTermID", this.userDefaultDetails.DefaultTermID.toString());
            sessionStorage.setItem("DefaultTermName", this.userDefaultDetails.DefaultTerm.toString());
            sessionStorage.setItem("DefaultClassID", this.userDefaultDetails.DefaultClassID.toString());
            sessionStorage.setItem("DefaultClass", this.userDefaultDetails.DefaultClass.toString());
            sessionStorage.setItem("DefaultPaymentType", this.userDefaultDetails.DefaultPaymentType.toString());
            sessionStorage.setItem("TermYears", this.userDefaultDetails.TermYears.toString());
            sessionStorage.setItem("GraphPalette", this.userDefaultDetails.GraphPallete.toString());
            sessionStorage.setItem("PreferredScanner", this.userDefaultDetails.PreferredScanner.toString());
            sessionStorage.setItem("FullName", this.userDefaultDetails.Name.toString());
            sessionStorage.setItem("UserProfile", this.userDefaultDetails.ProfileName.toString());
            sessionStorage.setItem("LastLoginDate", this.userDefaultDetails.LastLoginDate.toString());
            sessionStorage.setItem("LastLoginTime", this.userDefaultDetails.LastLoginTime.toString());
            sessionStorage.setItem("PasswordRecoveryOption", this.userDefaultDetails.PasswordRecoveryOption.toString());
            sessionStorage.setItem("LoggedIn", "true");

            sessionStorage.setItem("CaptureHeadmasterComments", this.userDefaultDetails.CaptureHeadmasterComments.toString());
            sessionStorage.setItem("Administration", this.userDefaultDetails.Administration.toString());
            sessionStorage.setItem("Students", this.userDefaultDetails.Students.toString());
            sessionStorage.setItem("Fees", this.userDefaultDetails.Fees.toString());
            sessionStorage.setItem("Exams", this.userDefaultDetails.Exams.toString());
            sessionStorage.setItem("Communication", this.userDefaultDetails.Communication.toString());
            sessionStorage.setItem("ResourceCentre", this.userDefaultDetails.ResourceCentre.toString());
            sessionStorage.setItem("Reports", this.userDefaultDetails.Reports.toString());
            sessionStorage.setItem("Maintenance", this.userDefaultDetails.Maintenance.toString());
            sessionStorage.setItem("Settings", this.userDefaultDetails.Settings.toString());
            sessionStorage.setItem("Transport", this.userDefaultDetails.Transport.toString());
            sessionStorage.setItem("Accomodation", this.userDefaultDetails.Accomodation.toString());
            sessionStorage.setItem("Timetable", this.userDefaultDetails.Timetable.toString());
            sessionStorage.setItem("eLearning", this.userDefaultDetails.eLearning.toString());
            sessionStorage.setItem("Library", this.userDefaultDetails.Library.toString());

            // sessionStorage.setItem("Expenditure", this.userDefaultDetails.Expenditure.toString());            

            this.myapp.getMenu();
            this.appService.setUserLoggedIn(true)
            this.router.navigate(['/', 'home']);
          }
          else if (responce.Status == ResponseStatus.Failure) {
            this.messageDialog.show(responce.StatusDescription, DialogMessageTypes.Information);
          }
          else {
            this.messageDialog.show("A system error was encountered trying to change the password.", DialogMessageTypes.SystemError);
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("A system error was encountered trying to change the password.", DialogMessageTypes.SystemError);
        }
      )
    }
  }

  onKeyPressed(e) {
    if (e.keyCode == 13) {
      this.login();
    }
  }
}

class LoginDetails {
  public Username: String;
  public Password: String;
}

export class UserAuthenticationResponce {
  public Response: ResponseObject;
  public UserDetails: UserDetail;
  public LoggedInStudentDetails: LoggedInStudentDetails;
  public ChangePassword: Boolean;
  public GUID: String;
  public LicenseExpiryDate: String;
  public LicenseDaysLeft: String;
  public LicensedStudentsBalance: String;
  public UnLicensedStudentsBalance: String;
  public PasswordExpiryDate: String;
  public PaymentReceiptOption: String;
  public TeacherID: String;
  public CommentsSource:String;
  public SMSsEnabled: Boolean;
  public ExamTopicsEnabled: Boolean;
  public ManualStudentNumbers: Boolean;
  public BehaviourCommentsEnabled:Boolean;
  public DefaultAbsentStudentNotification: String;
  public UserIdleSessionTimeOut: String;
  public UserIdleSessionTimeOutWarning: String;
  public RestrictedEndOfTermReports:Boolean;
}

class ChangePasswordDetails {
  public Username: String;
  public FullName: String;
  public NewPassword: String;
  public CurrentPassword: String;
  public PasswordHint: String;
}

class LoggedInStudentDetails {
  public StudentNumber: String;
  public Name: String;
  public ClassID: Number;
  public TermYears: Number;
  public SchoolName: String;
}